import { FormattedMessage, useIntl } from 'react-intl';

import { useToast } from '~/eds/src/components/hooks/useToast';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { Text } from '~/eds/src/components/Text/Text';
import { api } from '~/redux/api/createApi';

import { ExtendedPartyModalProps } from '../types';

export const DeletePartyModal = ({
  onHide,
  party,
  clientId,
}: ExtendedPartyModalProps) => {
  const { toast } = useToast();
  const intl = useIntl();

  const [deleteParty, { isLoading }] = api.endpoints.deleteParty.useMutation();

  const children = (
    <Text>
      <FormattedMessage
        id="DeletePartyModal.confirmationText"
        defaultMessage="Are you sure you want to delete {partyName}? You won't be able to undo this action."
        description="Confirmation message for deleting a party. Example: partyName = 'ABC Corporation'"
        values={{ partyName: party.name }}
      />
    </Text>
  );
  return (
    <Modal
      children={children}
      enableHideOnPrimaryAction={true}
      isVisible={true}
      primaryAction={{
        isLoading,
        text: intl.formatMessage({
          id: 'DeletePartyModal.deleteButton',
          defaultMessage: 'Delete',
          description: 'Delete button text',
        }),
        onClick: () => {
          deleteParty({
            isInternal: party.isInternal,
            party,
            clientId,
          })
            .then(() => {
              toast({
                message: intl.formatMessage(
                  {
                    id: 'DeletePartyModal.successMessage',
                    defaultMessage:
                      'Party "{partyName}" has been removed from the list.',
                    description:
                      'Success message when party is deleted. Example: partyName = "ABC Corporation"',
                  },
                  {
                    partyName: party.name,
                  },
                ),
                status: 'success',
              });
            })
            .catch((error) => {
              toast({
                message: `${error.response.data.detail}`,
                status: 'danger',
              });
            });
          onHide();
        },
        variant: 'danger',
      }}
      onHide={onHide}
      title={intl.formatMessage({
        id: 'DeletePartyModal.modalTitle',
        defaultMessage: 'Delete Selected Party?',
        description: 'Modal title for deleting party',
      })}
    />
  );
};
